import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form'
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import buscarAgendamentosViagens from '../../actions/agendamento-viagem/buscarAgendamentosViagens';
import AgendamentoViagem from './AgendamentoViagem';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import selecionarAgendamentoViagem from '../../actions/agendamento-viagem/selecionarAgendamentoViagem';

import PainelFiltragem from '../agendamento-viagem/PainelFiltrosAgendamentoViagem';
import {alterouFiltro} from '../../util/filtros';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Veículo</div>
            <div className="col">Período</div>
            <div className="col">Contratante</div>
            <div className="col ml-md-2">Valor Total</div>
            <div className="col">Valor Unitário</div>
            <div className="col">Quilometragem</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarAgendamentoViagem extends Component {

    componentDidMount() {
        this.props.selecionarAgendamentoViagem(null);
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarAgendamentosViagens(this.props.empresaSelecionada.id, this.props.filtrosAdicionados);
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarAgendamentosViagens(this.props.empresaSelecionada.id, this.props.filtrosAdicionados);
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoAgendamento() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row col-md-12 mb-4">
                    <div className="row col-md-4">
                        <button className="btn btn-laranja"
                            onClick={() => {
                                this.props.reset('formularioPainelCadastroAgendamentoViagem')
                                this.props.selecionarAgendamentoViagem(null)
                                this.props.history.push('/painel-cadastro-agendamento-viagem')
                            }}>
                            Criar Agendamento
                        </button>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirAgendamentosViagens() {
        if (!this.props.agendamentosViagens || this.props.agendamentosViagens.length == 0) {
            return <div>Nenhum agendamento de viagem.</div>;
        }

        return this.props.agendamentosViagens.map(it =>
            <AgendamentoViagem  key={`agendamento-viagem-${it.id}`} agendamnetoViagem={it} /> );
    }

    exibirTabelaAgendamentosViagens() {
        return (<div className="col-12 conteudo-internas">
            {this.props.agendamentosViagens && this.props.agendamentosViagens.length != 0 && <CabecalhoTabela />}
            <div className="lista-table">
                {this.exibirAgendamentosViagens()}
            </div>
        </div>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className='col-md-12'>
                        <Titulo texto="Agendamento de Viagens" urlRetorno="/gestao-empresa" />
                    </div>
                    <div className="col-12 filtro-busca">
                        <PainelFiltragem/>
                    </div>

                    {this.exibirBotaoNovoAgendamento()}
                    {this.exibirTabelaAgendamentosViagens()}
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        agendamentosViagens: state.agendamentosViagens.agendamentos,
        filtrosAdicionados: state.filtrosAdicionadosAgendamentoViagem
    });

export default withRouter(connect(mapStateToProps,
    {
        buscarAgendamentosViagens,
        selecionarAgendamentoViagem
    })(reduxForm({
    form: 'formularioAgendamentoViagem'
})(PainelGerenciarAgendamentoViagem)))
